import { render, staticRenderFns } from "./ListData.vue?vue&type=template&id=ad23704a&lang=pug"
import script from "./ListData.vue?vue&type=script&lang=js"
export * from "./ListData.vue?vue&type=script&lang=js"
import style0 from "./ListData.vue?vue&type=style&index=0&id=ad23704a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports